export default __webpack_public_path__ + "static/media/logo_placeholder.8f44b332.png";